module.exports = __webpack_public_path__ + "img/3.5c93b024.jpg";